import { AuthCheck } from '@/components/auth-check.component';
import { Head } from '@/components/head.component';
import {
  OnboardingFlow,
  type OnboardingFlowStep,
} from '@/containers/onboarding/onboarding-flow.component';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';

type Search = { step?: Exclude<OnboardingFlowStep, 'about'> };

export const Route = createFileRoute('/onboarding')({
  validateSearch: (search: Record<string, unknown>): Search => ({
    step:
      search.step === 'connect' ||
      search.step === 'trial' ||
      search.step === 'customize'
        ? search.step
        : undefined,
  }),
  component: RouteComponent,
});

function RouteComponent() {
  const { step } = Route.useSearch();
  const navigate = useNavigate();
  const goTo = useCallback(
    (next: OnboardingFlowStep) =>
      void navigate({
        to: '/onboarding',
        search: next === 'about' ? {} : { step: next },
      }),
    [navigate]
  );
  return (
    <>
      <Head heading='Onboarding' />
      <AuthCheck>
        <OnboardingFlow step={step ?? 'about'} onStep={goTo} />
      </AuthCheck>
    </>
  );
}
